module.exports = __webpack_public_path__ + "img/skimmer_stopped.4eee87b4.svg";